import './CampaignCard.css'
import BaseComponent from "../../../../lib/components/BaseComponent";
import DialogCloneCampaign from "../../../../lib/components/dialogs/DialogCloneCampaign";
import CM from "../../../model/system/CM";
import RemoveCampaign from "../../../model/service/campaign/dto/RemoveCampaign";
import {toast} from "react-toastify";
import UpdateCampaignStatus from "../../../model/service/campaign/dto/UpdateCampaignStatus";
import React from "react";
import uploadThumbnail from './UploadThumbnail.png';
import Upload from "../../../../lib/components/Upload";
import T from "../../../model/system/text_translations/Translator";
import image1 from './defaultImages/bild_1.jpg';
import image2 from './defaultImages/bild_2.jpg';
import image3 from './defaultImages/bild_3.jpg';
import image4 from './defaultImages/bild_4.jpg';
import image5 from './defaultImages/bild_5.jpg';
import image6 from './defaultImages/bild_6.jpg';
import image7 from './defaultImages/bild_7.jpg';
import image8 from './defaultImages/bild_8.jpg';
import AddCampaignImg from "../../../model/service/campaign/dto/AddCampaignImg";
import CampaignService from "../../../model/service/campaign/CampaignService";
import shortid from "shortid";
import ConfirmationDialog from "../../../../lib/components/dialogs/ConfirmationDialog";
import UpdateCampaign from "../../../model/service/campaign/dto/UpdateCampaign";
import {Delete, Refresh, CopyAll, AddPhotoAlternateOutlined, Circle} from "@mui/icons-material";
import {IconButton, Typography} from "@mui/material";
import MenuItem from "../menu/MenuItem";
import ReadCampaignCloneInfo from "../../../model/service/campaign/dto/ReadCampaignCloneInfo";


class CampaignBase extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      image: null,
      isLoading: false,
      thumbnailChange: false,
      campaignMoreMenuAnchorEl: null,
      statusMenuAnchorEl: null,
      deleteDialogOpen: false,
      updateDialogOpen: false
    }
    this.defaultImages = [image1, image2, image3, image4, image5, image6, image7, image8];
    this.storageId = 'CampaignCard_' + shortid();
    this.campaignMoreMenuItems = [<MenuItem key={shortid()} onClick={(e) => this.onCloneClick(e)}>
      <CopyAll/>{T.label_clone()}
    </MenuItem>, <MenuItem key={shortid()} onClick={(e) => this.onUpdateClick(e)}>
      <Refresh/>{T.label_update()}
    </MenuItem>, <MenuItem key={shortid()} onClick={(e) => this.onDeleteClick(e)}>
      <Delete/>{T.label_delete()}
    </MenuItem>, <MenuItem key={shortid()} onClick={(e) => this.onThumbnailChangeClick(e)}>
      <AddPhotoAlternateOutlined/>{T.action_change_thumbnail()}
    </MenuItem>];

    this.statusMenuItems = [<MenuItem key={shortid()} onClick={(e) => this.onCampaignStatusChange(e, 1)}>
      <Circle color='primary' className='p-1'/>{T.label_filter_editing()}
    </MenuItem>, <MenuItem key={shortid()} onClick={(e) => this.onCampaignStatusChange(e, 2)}>
      <Circle className='p-1 text-amber-500'/>{T.label_filter_maintenance()}
    </MenuItem>, <MenuItem key={shortid()} onClick={(e) => this.onCampaignStatusChange(e, 3)}>
      <Circle color='secondary' className='p-1'/>{T.label_filter_published()}
    </MenuItem>, <MenuItem key={shortid()} onClick={(e) => this.onCampaignStatusChange(e, 4)}>
      <Circle color='error' className='p-1'/>{T.label_filter_closed()}
    </MenuItem>];

  }

  getColorClassFromStatus(status, doBorder) {
    switch (status) {
      case 1:
      default:
        return doBorder ? 'border-cn-color-secondary' : 'text-cn-color-secondary';
      case 2:
        return doBorder ? 'border-amber-600' : 'text-amber-600';
      case 3:
        return doBorder ? 'border-cn-color-primary' : 'text-cn-color-primary';
      case 4:
        return doBorder ? 'border-cn-color-static-red' : 'text-cn-color-static-red';
    }
  }

  createStatusIcon() {
    let status = this.props.campaign.status;
    let colorClass = this.getColorClassFromStatus(status);
    return <IconButton className='absolute -left-7 top-[-44px] cursor-pointer'
                       onClick={(e) => this.onStatusMenuClick(e)}>
      <Circle className={colorClass + ' rounded-full stroke-transparent'}/>
    </IconButton>;
  }

  onMoreButtonClick(e) {
    this.setState({campaignMoreMenuAnchorEl: e.currentTarget});
  }

  onThumbnailChangeClick() {
    if (this.state.thumbnailChange) {
      this.state.thumbnailChange = false;
      this.state.image = null;
    } else {
      this.state.thumbnailChange = true;
      this.state.image = <Upload uploadArea={<img className='cursor-pointer object-contain w-[55px] h-[55px]' alt='Thumbnail'
                                                  src={uploadThumbnail}/>}

                                 className='cursor-pointer' accept='image/*' draggable hideHint hideProgress
                                 onUploadDone={(response) => {
                                   if (response.success && response.data.id !== '') {
                                     let uploadedFile = response.data.fileUploadEntities[0];
                                     let dto = new AddCampaignImg(parseInt(this.props.campaign.id),
                                       uploadedFile.resourceId, uploadedFile.name);
                                     this.doDataFetch(dto, CampaignService.NAME,
                                       dtoResponse => {
                                         if (dtoResponse.success) {
                                           toast.success('Thumbnail wurde erfolgreich aktualisiert.');
                                           this.props.reloadCampaigns();
                                         } else {
                                           toast.error('Beim Aktualisieren ist etwas schief gelaufen!');
                                         }
                                       });
                                   } else {
                                     toast.error(response.message);
                                   }
                                 }} uploadDialogCancelled={() => {
        this.state.image = null;
        this.state.thumbnailChange = false;
        this.setState(this.state);
      }}/>

    }
    this.setState({campaignMoreMenuAnchorEl: null});
  }

  onCampaignStatusChange(e, newStatus) {
    let self = this;
    let dto = new UpdateCampaignStatus(this.props.campaign.id, newStatus);
    CM.get().doJsonAjax(CM.get().getServiceUrl('campaign'), dto, (response) => {
      if (response.success) {
        toast.success('Campaign Status wurde erfolgreich aktualisiert!');
        self.props.reloadCampaigns();
      } else {
        toast.error(response.message);
      }
    });
    this.setState({statusMenuAnchorEl: null});
  }

  onStatusMenuClick(e) {
    this.setState({statusMenuAnchorEl: e.currentTarget});
  }

  onCloneClick() {
    let self = this;
    this.doDataFetch(new ReadCampaignCloneInfo(this.props.campaign.id), 'campaign',
      (response) => {
        if (response.success) {
          self.setState(self.state);
          CM.get().setMainDialog(<DialogCloneCampaign
            data={response.data}
            onCloneButtonClick={() => {
              CM.get().closeMainDialog();
              this.props.reloadCampaigns();
            }} campaignId={this.props.campaign.id}/>);
          this.setState({campaignMoreMenuAnchorEl: null});
        } else {
          toast.error('Die Anfrage hat nicht funktioniert:\n' + response.message);
        }
      });
  }

  onDeleteClick() {
    this.setState({campaignMoreMenuAnchorEl: null, deleteDialogOpen: true});
  }

  createDeleteCampaignDialog() {
    return <ConfirmationDialog
      onCancelClick={() => this.setState({isLoading: false, deleteDialogOpen: false})}
      isOpen={this.state.deleteDialogOpen}
      isLoading={this.state.isLoading}
      title='Campaign löschen'
      onConfirmClick={this.doDeleteCampaign}>
      Möchten Sie die Campaign&nbsp;
      <Typography color='error' className='underline font-bold italic inline'>
        {this.props.campaign.name}
      </Typography> löschen?
    </ConfirmationDialog>
  };

  doDeleteCampaign = () => {
    let self = this;
    let campaignId = this.props.campaign.id;
    this.setState({isLoading: true});
    CM.get().doJsonAjax(CM.get().getServiceUrl('campaign'), new RemoveCampaign(campaignId), (response) => {
      if (response.success) {
        self.setState({isLoading: false, deleteDialogOpen: false});
        toast.success('Campaign wurde gelöscht.');
        self.props.reloadCampaigns();
      } else {
        toast.error(response.message);
      }
    });
  }

  onUpdateClick() {
    this.setState({campaignMoreMenuAnchorEl: null, updateDialogOpen: true});
  }

  createUpdateCampaignDialog() {
    return (<ConfirmationDialog
      isOpen={this.state.updateDialogOpen}
      onCancelClick={() => this.setState({isLoading: false, updateDialogOpen: false})}
      isLoading={this.state.isLoading}
      title='Campaign aktualisieren'
      onConfirmClick={this.doUpdateCampaign} confirmButtonColor='secondary'>
      Möchten Sie die Campaign
      <Typography color='secondary' variant='overline' className='underline font-bold italic px-1'>
        {this.props.campaign.name}
      </Typography>
      aktualisieren?
    </ConfirmationDialog>)
  };

  doUpdateCampaign = () => {
    let self = this;
    this.setState({isLoading: true});
    let update = new UpdateCampaign(this.props.campaign.id);
    CM.get().doJsonAjax(CM.get().getServiceUrl(CampaignService.NAME), update, (response) => {
      if (response.success) {
        toast.success('Campaign wurde erfolgreich aktualisiert.');
        self.setState({isLoading: false, updateDialogOpen: false});
      } else {
        toast.error(response.message);
      }
    });
  }

  onCardClick(e) {
    if (this.props.onCardClick) {
      this.props.onCardClick(e, this.props.campaign);
    }
  }
}

export default CampaignBase;